import { getData, putData } from '../plugins/ApiCalls'

export function fetchWhiteLabel(data) {
  return getData('whitelabels' + (data && data.id ? '/' + data.id : ''))
}

export function updateWhiteLabel(data) {
  return putData('whitelabels/' + data.id, data)
}
